import React from 'react';
import '../../styles/Auth/Header.css';
import ProfileDropdown from './ProfileDropDown.jsx';
import { useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';

const Header = ({ onToggleSidebar }) => {
  const location = useLocation();

  const isPosPage = location.pathname === '/pos' || location.pathname.startsWith('/pos/');

  return (
    !isPosPage ? (
      <header className={`dashboard-header ${isPosPage ? 'pos-header' : ''}`}>
        {onToggleSidebar && (
          <button className="sidebar-toggle-btn" onClick={onToggleSidebar} aria-label="Toggle Sidebar">
            <Icon icon="mdi:menu" />
          </button>
        )}
        <ProfileDropdown />
      </header>
    ) : null
  );
};

export default Header;
